import { useApi } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

export interface MarkLeadResolvedParams {
  leadId: number;
  expertIds: number[];
}

export function useMarkLeadResolved() {
  const api = useApi();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending, error, isSuccess } = useMutation({
    mutationFn: async ({ leadId, expertIds }: MarkLeadResolvedParams) => {
      return api.admin.leadsV2.matchExperts({
        params: { id: leadId },
        body: { 
          expert_ids: expertIds,
          mark_as_matched: true,
        },
      });
    },
    onSuccess: () => {
      // Invalidate all leads queries to refetch the data
      queryClient.invalidateQueries({ queryKey: ['admin', 'leads-v2'] });
    },
  });

  return {
    mutateAsync,
    isPending,
    error,
    isSuccess,
  };
}
